import React from 'react';
import { isFragment } from 'react-is';
import { isNil } from 'lodash';

export const getDisplayName = Comp => {
  if (typeof Comp === 'string') return Comp;
  if (!Comp) return '';
  return Comp.displayName || Comp.name;
};

const toMap = (allowedComponents, children) => {
  let result = {};
  React.Children.forEach(children, child => {
    if (isNil(child)) return;
    const compName = getDisplayName(child.type);
    if (allowedComponents.includes(compName)) result = { ...result, [compName]: child };
    else if (isFragment(child)) result = { ...result, ...toMap(allowedComponents, child.props.children) };
  });
  return result;
};

export const createMapChildrenTypes = allowedComponents => children => toMap(allowedComponents, children);
